<template>
<div class="chapter">
<div class="inner_page">
<p class="paranoindent1" style="padding-top:14em">EVOLUTION OF THE AMERICAN DIESEL LOCOMOTIVE</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 008_Other1.vue?fd866a42